// Porte de submit_post_via_hidden_form / criação manual de <a> + .click() do
// legado — o padrão de "gerar um arquivo e descartar" se repete em qualquer
// export/backup/relatório baixável.
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
